import { VariantType, useSnackbar } from "notistack";

function UseSnackbar() {
  const { enqueueSnackbar } = useSnackbar();
  const showMessage = (
    message: string | null,
    variant: VariantType = "error"
  ) => {
    if (message === null) {
      return;
    }
    enqueueSnackbar(message, {
      variant: variant,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      },
      autoHideDuration: 3500
    });
  };
  return showMessage;
}

export default UseSnackbar;
